import React from 'react'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useCookies } from 'react-cookie'
import { Table, TableRow, Typography, TableCell, TableContainer, Paper } from '@material-ui/core'

const daysOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

function ValidSchedule({ schedule, title }) {
  const { t, i18n } = useTranslation()
  let defaultLanguage = 'FI'
  const [cookies] = useCookies(['selectedLanguage'])
  if (cookies.selectedLanguage) {
    defaultLanguage = cookies.selectedLanguage
  }

  useEffect(() => {
    if (defaultLanguage) {
      let i18lang =
        defaultLanguage === 'GB' ? 'en' : defaultLanguage.toLowerCase()
      i18n.changeLanguage(i18lang.toLowerCase())
    }
  }, [defaultLanguage, i18n])

  if (!schedule) return null
  if (typeof schedule !== 'object') return null
  const { active, slots } = schedule
  const timesPerDay = [[], [], [], [], [], [], []] // 1=Monday ... 7=Sunday
  Object.keys(slots).forEach((slotid) => {
    const slot = slots[slotid]
    const starttime = slot.starttime
    const endtime = slot.endtime
    slot.days.forEach((day) => {
      timesPerDay[day - 1].push(starttime + ' - ' + endtime)
    })
  })

  return (
    <React.Fragment>
      {slots && Object.keys(slots).length > 0 && (
        <TableContainer>
          {title && (
            <Typography variant='h6' style={{ marginTop: 10, marginBottom: 10 }}>
              {t(title)}
            </Typography>
          )}
          <Table size='small' aria-label='a dense table'>
            {timesPerDay.map(
              (times, index) =>
                times.length > 0 && (
                  <TableRow key={index}>
                    <TableCell style={{ borderBottom: 'none' }}>
                      <strong>{t(daysOfWeek[index])}</strong>{' '}
                    </TableCell>
                    <TableCell style={{ borderBottom: 'none' }}>{times.join(', ')}</TableCell>
                  </TableRow>
                )
            )}
          </Table>
        </TableContainer>
      )}
    </React.Fragment>
  )
}

export default ValidSchedule
